// Constants for product types
export const PRODUCT_TYPES = {
  PASS: "PASS",
  TICKET: "TICKET",
  TOUR: "TOUR",
  SIM: "SIM",
  MUSICAL: "MUSICAL",
  INACTIVE: "INACTIVE",
};

// Constants for attribute types
export const ATTRIBUTE_TYPES = {
  DATA_PACKAGE: "DATA_PACKAGE",
  SIM_VALIDITY: "SIM_VALIDITY",
};

// Constants for attribute types
export const PRODUCT_STATUS = {
  INACTIVE: "INACTIVE",
};

// Other constants
export const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";

export const ERROR_CODES = {
  USER_EXISTS: 1002,
  EMAIL_EXISTS: 1012,
};

export const LCS_CART_PREFIX = "CART_PRODUCT_V6.";
export const LCS_HASH_PREFIX = "CART_HASH_V6.";

export const SHOPPING_CART_MODE = {
  UPDATE_BOOKING: "UPDATE_BOOKING",
};
